import i18n from '../../i18n';

export default function languageTranslationWithVariables(component, variables) {
  return i18n.t(component, variables);
}
